import React from 'react';
import cn from 'classnames';
import { useRenderFormFields } from 'Components/Admin/Form';
import useValidationSchema from 'Components/Admin/Form/hooks/useValidationSchema';

import AdminModal from 'Components/Admin/AdminModal/AdminModal';
import { Formik } from 'formik';

const ModalForm = ({
                     title,
                     onClose,
                     formItems,
                     onSubmit,
                     initialValues,
                     isBlocks,
                     className,
                     testId,
                     renderCustomFooter,
                   }) => {
  const items = useRenderFormFields(formItems, isBlocks);
  const validationSchema = useValidationSchema(formItems, isBlocks);

  const injectFormProps = (formProps) => {
    return renderCustomFooter && ((footerProps) => renderCustomFooter({ ...footerProps, formProps }));
  };

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
    >
      {
        (props) => (
          <AdminModal
            title={title}
            onClose={onClose}
            onSuccess={props.submitForm}
            renderCustomFooter={injectFormProps(props)}
            className={cn('admin-form', className)}
            testId={testId}
            direction="top"
          >
            {items}
          </AdminModal>
        )
      }
    </Formik>
  );
};

export default ModalForm;
